import React, { createContext, useContext, useRef, useCallback } from 'react'

const ScrollContext = createContext(null)

export const ScrollProvider = ({ children }) => {
  const scrollToOtherKitsRef = useRef(null)

  const registerScrollToOtherKits = useCallback((fn) => {
    scrollToOtherKitsRef.current = fn
  }, [])

  const scrollToOtherKits = useCallback(() => {
    if (scrollToOtherKitsRef.current) {
      scrollToOtherKitsRef.current()
    }
  }, [])

  return (
    <ScrollContext.Provider value={{ registerScrollToOtherKits, scrollToOtherKits }}>{children}</ScrollContext.Provider>
  )
}

export const useScrollToOtherKits = () => {
  const context = useContext(ScrollContext)
  if (!context) {
    throw new Error('useScrollToOtherKits must be used within ScrollProvider')
  }
  return context
}
